/**
 * 対話エンジンの設定
 *
 * 評価指標の制限値やセッション設定などの調整可能なパラメータを定義します。
 */
export const dialogueConfig = {
  // 評価指標の制限値設定
  METRICS_MIN: 0,
  METRICS_MAX: 10,

  // セッション設定
  MAX_MESSAGE_COUNT: 20,
};
